import { useProlongationSubmit } from './MultiStepWizard/hooks/useProlongationSubmit';
import { ModuleProps } from './MultiStepWizard/MultiStepWizard';
import { MultiStepWizardContainer } from './MultiStepWizard/MultiStepWizardContainer';

export const ProlongationModule = (props: ModuleProps) => {
  const { handleSubmit } = useProlongationSubmit();

  return (
    <MultiStepWizardContainer
      {...props}
      onSubmit={handleSubmit}
      name="prolongation"
      moduleName="prolongation-module"
    />
  );
};
